/**
 * The borrower's own fees worksheet.
 *
 * Read-only by design: the officer owns the figures, and the borrower reads
 * the same live worksheet rather than a copy taken when it was sent. There is
 * no mutation here and there should never be one — the portal's refresh is the
 * whole point of the live model, which is why the query is not cached across
 * mounts the way a static document would be.
 *
 * The server answers 403 on a worksheet the officer has not shared yet and 404
 * on a loan this consumer is not a borrower on. Both are expected states, not
 * failures, and the panel renders each of them differently.
 */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getHeaders } from 'auth/auth';
import { api as loanServiceAPI } from 'constants/constant';

export const consumerFeesWorksheetAPI = createApi({
  reducerPath: 'consumerFeesWorksheet',
  baseQuery: fetchBaseQuery({ baseUrl: loanServiceAPI, credentials: 'include' }),
  tagTypes: ['ConsumerFeesWorksheet'],
  endpoints: (builder) => ({
    getMyFeesWorksheet: builder.query({
      query: ({ applicationId }) => ({
        url: `b2c/loan/applications/${applicationId}/fees-worksheet`,
        method: 'GET',
        headers: getHeaders(),
      }),
      providesTags: ['ConsumerFeesWorksheet'],
    }),
  }),
});

export const { useGetMyFeesWorksheetQuery } = consumerFeesWorksheetAPI;
